<div class="d-flex flex-column">
  <div class="d-flex proposal-details-row" *ngIf="insuranceContract.proposalInformation.proposalName">
    <div class="info-col">{{'createProposal.proposalNameShort' | translate}}:</div>
    <div>{{insuranceContract.proposalInformation.proposalName ?? '-'}}</div>
  </div>
  <div class="d-flex proposal-details-row" *ngIf="insuranceContract.proposalInformation.classificationTerm">
    <div class="info-col">{{'createProposal.classificationTermShort' | translate}}:</div>
    <div>{{insuranceContract.proposalInformation.classificationTerm ?? '-'}}</div>
  </div>
  <div class="d-flex proposal-details-row" *ngIf="insuranceContract.proposalNumber">
    <div class="info-col">{{'createProposal.proposalNumber' | translate}}:</div>
    <div>{{insuranceContract.proposalNumber ?? '-'}}</div>
  </div>
  <div class="d-flex proposal-details-row" *ngIf="insuranceContract.proposalInformation.deadline">
    <div class="info-col">{{'createProposal.deadline' | translate}}:</div>
    <div>{{insuranceContract.proposalInformation.deadline | date : ('dateFormat' | translate)}}</div>
  </div>
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'proposalDetails.privateProposal'|translate}}:</div>
    <div>
      <div>{{"proposalDetails." + (insuranceContract.proposalInformation.privateProposal ? "yes" : "no") | translate}}</div>
    </div>
  </div>
  <div class="d-flex flex-column">
    <div class="d-flex proposal-details-row">
      <div class="private-list">
        <ul>
          <li *ngFor="let user of usersAllowedToView">
            {{user.company.name}} - <span class="username">{{user.firstName}} {{user.lastName}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="d-flex proposal-details-row" *ngIf="(user$|async)?.id == insuranceContract.creator.id && insuranceContract.proposalInformation.emailsReceivedPDFWithDate && insuranceContract.proposalInformation.emailsReceivedPDFWithDate.length > 0">
    <div class="info-col">{{'createProposal.emailsReceivedPDFWithDate'|translate}}:</div>
  </div>
  <div class="d-flex flex-column" *ngIf="(user$|async)?.id == insuranceContract.creator.id">
    <div class="d-flex proposal-details-row">
      <div class="private-list">
        <ul>
          <li *ngFor="let emailWithDate of insuranceContract.proposalInformation.emailsReceivedPDFWithDate">
            {{ emailWithDate.split('/')[0] }} - <span class="username">{{ emailWithDate.split('/')[1] }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
